import React from 'react';
import './searchSection.scss';
import { ReactComponent as MagnifierIcon } from "./icons/MagnifierIcon.svg";
import { ReactComponent as CrossIcon } from "./icons/CrossIcon.svg";

interface SearchSectionProps {
	value: string;
	setValue: (newValue: string) => void;
}

const SearchSection = (props: SearchSectionProps) => {
	return (
		<div className="searchSection">
			<div className="searchSection__content">
				<div className="searchSection__content_magnifier">
					<MagnifierIcon />
				</div>
				<button
					className="searchSection__content_cross"
					onClick={() => props.setValue('')}
				>
					<CrossIcon />
				</button>
				<input
					value={props.value}
					onChange={(e) => {
						props.setValue(e.target.value)
					}}
					placeholder={'Search article'}
				/>
			</div>
		</div>
	);
};

export default SearchSection;